<span class="snack-bar-form">
    {{ 'FORM.MISSING_INFORMATION' | translate }}
</span>